import { mergeMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import React from 'react';

import get from 'lodash.get';
import { FormattedMessage } from 'react-intl';
import { EMPTY } from 'rxjs';

import { ModalService } from 'ui-components/services/modal-service';

import { GenericErrorRetryContainer } from '../../containers/generic-error-retry-container';
import Global from '../global-selectors';
import * as Actions from './customs.actions';
import * as Api from './customs.api';
import { messages } from './messages';

export const checkCustomsStatusForOrders = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.CHECK_CUSTOMS_STATUS_FOR_ORDERS_REQUEST),
    mergeMap((action) => {
      const state = getState();
      const { salesOrderIds } = action;
      return Api.checkSalesOrdersCustomsStatus(salesOrderIds).pipe(
        map((response) => {
          const data = get(response, 'data.customsStatusList');
          const mappedData = data.map((datum) => {
            return {
              ...datum,
              salesOrderNumber: Global.selectEntitiesSalesOrderProperty(state, {
                salesOrderId: datum.salesOrderId,
                property: 'orderNumber',
              }),
            };
          });
          return Actions.checkCustomsStatusForOrdersSuccess(mappedData);
        }),
        catchError(() => {
          ModalService.launchModal({
            component: GenericErrorRetryContainer,
            props: {
              action,
              title: <FormattedMessage {...messages.customsStatusErrorTitle} />,
              message: <FormattedMessage {...messages.customsStatusErrorMessage} />,
            },
          });
          return EMPTY;
        }),
      );
    }),
  );
};

export const checkCustomsStatusForFulfillmentPlans = (action$) => {
  return action$.pipe(
    ofType(Actions.CHECK_CUSTOMS_STATUS_FOR_FULFILLMENT_PLANS_REQUEST),
    mergeMap((action) => {
      const { fulfillmentPlanIds } = action;
      return Api.checkFulfillmentPlanCustomsStatus(fulfillmentPlanIds).pipe(
        map((response) => {
          const data = get(response, 'data.customsStatusList');
          return Actions.checkCustomsStatusForFulfillmentPlansSuccess(data);
        }),
        catchError(() => {
          ModalService.launchModal({
            component: GenericErrorRetryContainer,
            props: {
              action,
              title: <FormattedMessage {...messages.customsStatusErrorTitle} />,
              message: <FormattedMessage {...messages.customsStatusErrorMessage} />,
            },
          });
          return EMPTY;
        }),
      );
    }),
  );
};
